import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'

import { selectShouldPollDocument, selectShouldPollDocumentSummary } from '../../store/processDocument/processDocument'
import { startDocumentSummaryPolling, stopDocumentSummaryPolling } from '../../store/processDocument/documentSummary'
import { startDocumentPolling, stopDocumentPolling } from '../../store/processDocument/document'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentInitialization } from './Initialization/DocumentInitialization'
import { DocumentPoller } from './Poller/DocumentPoller'
import { Document } from './Document/Document'

export const DocumentPage = () => {
  const { documentId = null } = useParams()

  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  if (!documentId) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return <DocumentPageContent documentId={documentId} />
}

interface DocumentPageContentProps {
  documentId: string
}

const DocumentPageContent: React.FC<DocumentPageContentProps> = ({ documentId }) => {
  const dispatch = useAppDispatch()

  const shouldPollDocument = useAppSelector(selectShouldPollDocument)
  const shouldPollDocumentSummary = useAppSelector(selectShouldPollDocumentSummary)

  useEffect(() => {
    if (shouldPollDocument) {
      dispatch(startDocumentPolling())
    } else {
      dispatch(stopDocumentPolling())
    }
  }, [dispatch, shouldPollDocument])

  useEffect(() => {
    if (shouldPollDocumentSummary) {
      dispatch(startDocumentSummaryPolling())
    } else {
      dispatch(stopDocumentSummaryPolling())
    }
  }, [dispatch, shouldPollDocumentSummary])

  return (
    <div className='full-size-content'>
      <DocumentInitialization documentId={documentId} />
      <DocumentPoller documentId={documentId} />
      <Document />
    </div>
  )
}
